/**
 * Vrai sur un écran tactile (téléphone, tablette) : le doigt y remplace la
 * souris. Chrome sous Windows sait aussi partager un fichier ; seul le
 * téléphone doit passer par la feuille de partage pour imprimer.
 *
 * @returns {boolean} vrai sur un écran tactile
 */
export function ecranTactile() {
  return !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
}
